import styled from 'styled-components';
import { zIndex } from 'tokens';

export const Workspace = styled.div`
	flex: 1;
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	isolation: isolate;
`;

export const Panels = styled.div`
	z-index: ${zIndex.panel};
`;

export const LeftPanels = styled.div`
	position: absolute;
	display: flex;
	top: 0px;
	bottom: 0px;
`;
